var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isCommunicationChartCrossTeamSpaceNodeId, isCommunicationChartExternalSpaceNodeId, isCommunicationChartInternalMeetNodeId } from '@web/components/CommunicationNetworkGraph/core/communicationChart/constants';
import { getCommunicationChartLinkArrowSizes } from '@web/components/CommunicationNetworkGraph/core/communicationChart/linkDirection';
import { getCommunicationChartLinkEdgeId } from '@web/components/CommunicationNetworkGraph/core/communicationChart/linkEdgeId';
import { getCommunicationChartLinkDisplayTrend, getCommunicationChartLinkDisplayWeight } from '@web/components/CommunicationNetworkGraph/core/communicationChart/linkTrend';
import { getCommunicationChartLinkWidth } from '@web/components/CommunicationNetworkGraph/core/communicationChart/linkWidth';
import { isCommunicationChartChatChannel, isCommunicationChartDirectedChannel, isCommunicationChartEmailChannel, isCommunicationChartMeetChannel } from '@web/components/CommunicationNetworkGraph/core/communicationChart/types';
import { joinCommunicationChartElementClasses } from '@web/components/CommunicationNetworkGraph/core/communicationChart/utils';
import { COMMUNICATION_CHART_CHAT_EDGE_CONTROL_POINT_DISTANCE, COMMUNICATION_CHART_COLORS, COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE, COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE, COMMUNICATION_CHART_INTERNAL_DM_HUB_EDGE_CONTROL_POINT_DISTANCE, COMMUNICATION_CHART_INTERNAL_MEET_HUB_EDGE_CONTROL_POINT_DISTANCE, resolveCommunicationChartArrowGapPx, resolveCommunicationChartArrowWidthPx } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
import { resolveCommunicationChartOrgTeamHubEdgeTeamId } from '@web/components/CommunicationNetworkGraph/graph/communicationChartOrgTeamHubVisibility';
var resolveBaseChannelLineColor = function (channel, channelColors) {
    var _a, _b, _c;
    if (isCommunicationChartMeetChannel(channel)) {
        return (_a = channelColors === null || channelColors === void 0 ? void 0 : channelColors.meetLink) !== null && _a !== void 0 ? _a : COMMUNICATION_CHART_COLORS.meetLink;
    }
    if (isCommunicationChartEmailChannel(channel)) {
        return (_b = channelColors === null || channelColors === void 0 ? void 0 : channelColors.emailLink) !== null && _b !== void 0 ? _b : COMMUNICATION_CHART_COLORS.emailLink;
    }
    return (_c = channelColors === null || channelColors === void 0 ? void 0 : channelColors.chatLink) !== null && _c !== void 0 ? _c : COMMUNICATION_CHART_COLORS.chatLink;
};
var trendLineColor = function (channel, trend, channelColors) {
    if (trend === 'down') {
        return COMMUNICATION_CHART_COLORS.linkTrendDown;
    }
    if (trend === 'unchanged') {
        return COMMUNICATION_CHART_COLORS.linkTrendUnchanged;
    }
    if (channelColors) {
        return resolveBaseChannelLineColor(channel, channelColors);
    }
    return COMMUNICATION_CHART_COLORS.linkTrendUp;
};
var linkEdgeClasses = function (channel, link) {
    var displayTrend = getCommunicationChartLinkDisplayTrend(link.stats);
    return "channel-".concat(channel, " trend-").concat(displayTrend);
};
var linkChatArrowData = function (link, lineWidth) {
    var _a = isCommunicationChartInternalMeetNodeId(link.targetNodeId)
        ? { sourceArrowSize: 'none', targetArrowSize: 'medium' }
        : getCommunicationChartLinkArrowSizes(link.stats), sourceArrowSize = _a.sourceArrowSize, targetArrowSize = _a.targetArrowSize;
    return {
        sourceArrowSize: sourceArrowSize,
        targetArrowSize: targetArrowSize,
        sourceArrowWidthPx: resolveCommunicationChartArrowWidthPx(sourceArrowSize, lineWidth),
        targetArrowWidthPx: resolveCommunicationChartArrowWidthPx(targetArrowSize, lineWidth),
        sourceArrowGapPx: resolveCommunicationChartArrowGapPx(sourceArrowSize, lineWidth),
        targetArrowGapPx: resolveCommunicationChartArrowGapPx(targetArrowSize, lineWidth)
    };
};
var linkMeetArrowData = function () { return ({
    sourceArrowSize: 'none',
    targetArrowSize: 'none',
    sourceArrowWidthPx: 0,
    targetArrowWidthPx: 0,
    sourceArrowGapPx: 0,
    targetArrowGapPx: 0
}); };
var linkTouchesInternalMeetNode = function (link) {
    return isCommunicationChartInternalMeetNodeId(link.sourceNodeId) ||
        isCommunicationChartInternalMeetNodeId(link.targetNodeId);
};
var linkTouchesCrossTeamSpaceNode = function (link) {
    return isCommunicationChartCrossTeamSpaceNodeId(link.sourceNodeId) ||
        isCommunicationChartCrossTeamSpaceNodeId(link.targetNodeId);
};
var linkTouchesExternalSpaceNode = function (link) {
    return isCommunicationChartExternalSpaceNodeId(link.sourceNodeId) ||
        isCommunicationChartExternalSpaceNodeId(link.targetNodeId);
};
var resolveCommunicationChartChatControlPointDistance = function (link, channel) {
    if (linkTouchesExternalSpaceNode(link)) {
        var flowsTeamToExternal = !isCommunicationChartExternalSpaceNodeId(link.sourceNodeId) &&
            isCommunicationChartExternalSpaceNodeId(link.targetNodeId);
        return flowsTeamToExternal
            ? COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE
            : -COMMUNICATION_CHART_EXTERNAL_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE;
    }
    if (linkTouchesCrossTeamSpaceNode(link)) {
        var flowsTeamToCrossTeam = !isCommunicationChartCrossTeamSpaceNodeId(link.sourceNodeId) &&
            isCommunicationChartCrossTeamSpaceNodeId(link.targetNodeId);
        return flowsTeamToCrossTeam
            ? COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE
            : -COMMUNICATION_CHART_CROSS_TEAM_SPACE_CHAT_EDGE_CONTROL_POINT_DISTANCE;
    }
    if (linkTouchesInternalMeetNode(link)) {
        var flowsTeamToInternal = !isCommunicationChartInternalMeetNodeId(link.sourceNodeId) &&
            isCommunicationChartInternalMeetNodeId(link.targetNodeId);
        var usesInternalDmCurve = isCommunicationChartMeetChannel(channel) ||
            (isCommunicationChartChatChannel(channel) &&
                link.hubChatKind === 'internalDm');
        if (usesInternalDmCurve) {
            return flowsTeamToInternal
                ? COMMUNICATION_CHART_INTERNAL_DM_HUB_EDGE_CONTROL_POINT_DISTANCE
                : -COMMUNICATION_CHART_INTERNAL_DM_HUB_EDGE_CONTROL_POINT_DISTANCE;
        }
        return flowsTeamToInternal
            ? COMMUNICATION_CHART_INTERNAL_MEET_HUB_EDGE_CONTROL_POINT_DISTANCE
            : -COMMUNICATION_CHART_INTERNAL_MEET_HUB_EDGE_CONTROL_POINT_DISTANCE;
    }
    return COMMUNICATION_CHART_CHAT_EDGE_CONTROL_POINT_DISTANCE;
};
var resolveCommunicationChartControlPointDistance = function (link, channel) {
    var chatDistance = resolveCommunicationChartChatControlPointDistance(link, channel);
    return isCommunicationChartMeetChannel(channel)
        ? -chatDistance
        : chatDistance;
};
export var buildCommunicationChartEdgeElements = function (_a) {
    var channel = _a.channel, links = _a.links, linkWeightRange = _a.linkWeightRange, useOrgTeamHubReveal = _a.useOrgTeamHubReveal, channelColors = _a.channelColors;
    return links.map(function (link) {
        var displayWeight = getCommunicationChartLinkDisplayWeight(link.stats);
        var displayTrend = getCommunicationChartLinkDisplayTrend(link.stats);
        var lineColor = trendLineColor(channel, displayTrend, channelColors);
        var lineWidth = Math.max(getCommunicationChartLinkWidth(displayWeight, linkWeightRange), 1);
        var hubEdgeTeamId = useOrgTeamHubReveal
            ? resolveCommunicationChartOrgTeamHubEdgeTeamId(link)
            : null;
        var arrowData = isCommunicationChartDirectedChannel(channel)
            ? linkChatArrowData(link, lineWidth)
            : linkMeetArrowData();
        return {
            data: __assign(__assign(__assign(__assign(__assign(__assign({ id: getCommunicationChartLinkEdgeId(link, channel), source: String(link.sourceNodeId), target: String(link.targetNodeId), width: lineWidth, lineColor: lineColor, controlPointDistance: resolveCommunicationChartControlPointDistance(link, channel) }, (link.hubChatKind !== undefined
                ? { hubChatKind: link.hubChatKind }
                : {})), { statsWeight: link.stats.weight, statsPreviousWeight: link.stats.previousWeight }), (link.stats.sentCount !== undefined
                ? { statsSentCount: link.stats.sentCount }
                : {})), (link.stats.receivedCount !== undefined
                ? { statsReceivedCount: link.stats.receivedCount }
                : {})), (hubEdgeTeamId !== null ? { hubTeamId: hubEdgeTeamId } : {})), arrowData),
            classes: joinCommunicationChartElementClasses(linkEdgeClasses(channel, link), hubEdgeTeamId !== null && 'teamHubEdge', hubEdgeTeamId !== null && 'hubHidden', arrowData.sourceArrowSize !== 'none' && 'has-source-arrow', arrowData.targetArrowSize !== 'none' && 'has-target-arrow')
        };
    });
};
